export default function Footer({ scrollToSection }: { scrollToSection: (id: string) => void }) {
  return (
    <footer className="bg-[#1A3A5C] text-white pt-20 pb-10">
      <div className="max-w-6xl mx-auto px-8">
        {/* Top Section - 3 Columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 mb-20">
          {/* Column 1 - Brand */}
          <div>
            <p className="text-white text-xl font-bold tracking-widest mb-3">EngiMind</p>
            <p className="text-gray-300 text-base leading-loose">
              製造業専門の<br />AIコンサルティング<br />AIプロダクト開発
            </p>
          </div>

          {/* Column 2 - Menu */}
          <div>
            <h4 className="text-gray-400 text-base font-bold tracking-[0.2em] uppercase mb-5">
              MENU
            </h4>
            <ul className="space-y-4">
              <li>
                <button
                  onClick={() => scrollToSection('service')}
                  className="text-gray-300 text-base hover:text-white transition-colors cursor-pointer"
                >
                  サービス
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('solution')}
                  className="text-gray-300 text-base hover:text-white transition-colors cursor-pointer"
                >
                  AIによる課題解決
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('profile')}
                  className="text-gray-300 text-base hover:text-white transition-colors cursor-pointer"
                >
                  プロフィール
                </button>
              </li>
            </ul>
          </div>

          {/* Column 3 - Contact */}
          <div>
            <h4 className="text-gray-400 text-base font-bold tracking-[0.2em] uppercase mb-5">
              CONTACT
            </h4>
            <ul className="space-y-4">
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-300 text-base hover:text-white transition-colors cursor-pointer"
                >
                  お問い合わせ
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section - Large Watermark Text */}
        <div className="relative overflow-hidden mb-6">
          <div className="text-[#D4C5B0] font-black text-5xl md:text-6xl tracking-tighter opacity-[0.3] select-none leading-none">
            ENGIMIND
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-700 pt-6 flex flex-col md:flex-row items-center justify-between gap-2">
          <p className="text-gray-500 text-sm">
            &copy; 2024 EngiMind. All rights reserved.
          </p>
          <p className="text-gray-600 text-sm">
            Powered by EngiMind
          </p>
        </div>
      </div>
    </footer>
  );
}
